import { DialogContentText } from "@material-ui/core";
import React, { useEffect } from "react";
import { useState } from "react";
import CustomModal from "./custom-modal";
import InputText from "./input-text";

export default function RenameCopiedSimulation(props) {

  const [simulationName, setSimulationName] = useState('');
  const [simulationNameHasError, setSimulationNameHasError] = useState(false);
  const [simulationNameErrorText, setSimulationNameErrorText] = useState('');

  useEffect(() => {
    setSimulationName(props.initialName)
  }, [props.initialName]);

  const onSubmit = () => {
    if (!simulationName) {
      setSimulationNameHasError(true);
      setSimulationNameErrorText('Simulation name is required');
    } else {
      setSimulationNameHasError(false);
      setSimulationNameErrorText('');
      props.onSubmit(simulationName);
    }
  }

  return (
    <CustomModal
      size="medium"
      title="Clone simulation title"
      showModal={props.showModal}
      onCloseModal={() => props.onClose()}
      submitBtnText={'Update'}
      onSubmit={(e) => { e.preventDefault(); onSubmit(); }}
      submitBtnDisabled={false}
    >
      <>
        <DialogContentText color="textPrimary">
          This will be the title of the copied simulation. You can modify if needed.
        </DialogContentText>
        <form onSubmit={(e) => { e.preventDefault(); onSubmit(); }}>
          <div css="margin-top: 15px;">
            <InputText
              id={"copiedSimulationName"}
              label={"Title"}
              value={simulationName}
              disabled={false}
              selectAllText={true}
              onChange={(value) => { setSimulationName(value) }}
              hasError={simulationNameHasError}
              errorText={simulationNameErrorText}
            />
          </div>
        </form>
      </>
    </CustomModal>
  )
}